import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import GoogleCallback from "@/pages/GoogleCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import Register from "@/pages/Register";
import ResetPassword from "@/pages/ResetPassword";
import ClientPortal from "@/pages/ClientPortal";
import ClientEventDayMode from "@/pages/ClientEventDayMode";
import CrewPortal from "@/pages/CrewPortal";
import Dashboard from "@/pages/Dashboard";
import Business from "@/pages/Business";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import EventDayMode from "@/pages/EventDayMode";
import Clients from "@/pages/Clients";
import Vendors from "@/pages/Vendors";
import Team from "@/pages/Team";
import Tasks from "@/pages/Tasks";
import Rundown from "@/pages/Rundown";
import Payments from "@/pages/Payments";
import Invoices from "@/pages/Invoices";
import Receipts from "@/pages/Receipts";
import Packages from "@/pages/Packages";
import Documents from "@/pages/Documents";
import Meetings from "@/pages/Meetings";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";

const withLayout = (Comp) => (
  <ProtectedRoute allow="internal"><Layout><Comp /></Layout></ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/google" element={<GoogleCallback />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/portal" element={<ProtectedRoute allow="client"><ClientPortal /></ProtectedRoute>} />
            <Route path="/portal/event-day" element={<ProtectedRoute allow="client"><ClientEventDayMode /></ProtectedRoute>} />
            <Route path="/crew" element={<ProtectedRoute allow="crew"><CrewPortal /></ProtectedRoute>} />
            <Route path="/dashboard" element={withLayout(Dashboard)} />
            <Route path="/business" element={withLayout(Business)} />
            <Route path="/events" element={withLayout(Events)} />
            <Route path="/events/:id" element={withLayout(EventDetail)} />
            <Route path="/events/:id/day" element={<ProtectedRoute allow="internal"><EventDayMode /></ProtectedRoute>} />
            <Route path="/clients" element={withLayout(Clients)} />
            <Route path="/vendors" element={withLayout(Vendors)} />
            <Route path="/team" element={withLayout(Team)} />
            <Route path="/activity" element={withLayout(Tasks)} />
            <Route path="/tasks" element={<Navigate to="/activity" replace />} />
            <Route path="/rundown" element={withLayout(Rundown)} />
            <Route path="/payments" element={withLayout(Payments)} />
            <Route path="/invoices" element={withLayout(Invoices)} />
            <Route path="/receipts" element={withLayout(Receipts)} />
            <Route path="/packages" element={withLayout(Packages)} />
            <Route path="/documents" element={withLayout(Documents)} />
            <Route path="/meetings" element={withLayout(Meetings)} />
            <Route path="/reports" element={withLayout(Reports)} />
            <Route path="/settings" element={withLayout(Settings)} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
